var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-bottom": "50px" } },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "card-title",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_vm._v(_vm._s(_vm.$t("storage::in-stock::入库单信息")))]
          ),
          _c(
            "el-form",
            {
              ref: "order",
              staticClass: "stock-form",
              attrs: {
                model: _vm.order,
                "label-width": "120px",
                "label-position": "top",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storage::in-stock::in_type"),
                            prop: "stockType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-item",
                              attrs: {
                                popperAppendToBody: false,
                                clearable: "",
                                placeholder: _vm.$t(
                                  "storage::in-stock::please_select"
                                ),
                              },
                              model: {
                                value: _vm.order.stockType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "stockType", $$v)
                                },
                                expression: "order.stockType",
                              },
                            },
                            _vm._l(_vm.menuList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storage::in-stock::supplier"),
                            prop: "supplierId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-item",
                              attrs: {
                                popperAppendToBody: false,
                                clearable: "",
                                placeholder: _vm.$t(
                                  "storage::in-stock::please_select"
                                ),
                              },
                              on: { change: _vm.changeSupplier },
                              model: {
                                value: _vm.order.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "supplierId", $$v)
                                },
                                expression: "order.supplierId",
                              },
                            },
                            _vm._l(_vm.supplierList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storage::in-stock::relate_num"),
                            prop: "sourceNo",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "input-with-select input-item",
                              attrs: {
                                placeholder: _vm.$t(
                                  "storage::in-stock::input_holder"
                                ),
                              },
                              model: {
                                value: _vm.order.sourceNo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.order,
                                    "sourceNo",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "order.sourceNo",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { color: "#010517" },
                                  attrs: {
                                    slot: "prepend",
                                    popperAppendToBody: false,
                                  },
                                  slot: "prepend",
                                  model: {
                                    value: _vm.order.sourceNoType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.order, "sourceNoType", $$v)
                                    },
                                    expression: "order.sourceNoType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "storage::in-stock::purchase_order"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("storage::in-stock::order"),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "storage::in-stock::fullfillment_num"
                            ),
                            prop: "fulfillmentNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-item",
                            model: {
                              value: _vm.order.fulfillmentNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.order,
                                  "fulfillmentNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "order.fulfillmentNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.$route.params.id
                    ? [
                        _c(
                          "el-col",
                          { attrs: { ":span": 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("storage::in-stock::creator"),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.order.applicantditorName || "--"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "storage::in-stock::table_create_time"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.order.createTime || "--") +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storage::in-stock::instock_date"
                                ),
                                prop: "operTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticClass: "input-item",
                                attrs: {
                                  appendToBody: false,
                                  pickerOptions: _vm.pickerOptions,
                                  type: "date",
                                  placeholder: _vm.$t(
                                    "storage::in-stock::select_date"
                                  ),
                                },
                                model: {
                                  value: _vm.order.operTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.order, "operTime", $$v)
                                  },
                                  expression: "order.operTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storage::in-stock::third_bill_num"),
                            prop: "thirdPartyNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-item",
                            model: {
                              value: _vm.order.thirdPartyNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.order,
                                  "thirdPartyNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "order.thirdPartyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("storage::in-stock::remark") },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              rows: "4",
                              type: "textarea",
                              maxlength: "50",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.order.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "remark", $$v)
                              },
                              expression: "order.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "div",
            {
              staticClass: "card-title",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_vm._v(_vm._s(_vm.$t("storage::in-stock::入库商品信息")))]
          ),
          _c(
            "div",
            {
              staticClass: "mb-16",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-plus",
                        disabled: !_vm.order.supplierId,
                      },
                      on: { click: _vm.showAddSku },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("storage::in-stock::add_sku")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.order.supplierId,
                          expression: "order.supplierId",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.isImportSku = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("storage::in-stock::import")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.order.supplierId,
                          expression: "!order.supplierId",
                        },
                      ],
                      staticStyle: { "margin-left": "10px", color: "#d9001b" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("storage::in-stock::supplier_select_holder")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("span", [_vm._v("SKU")]),
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px", "margin-left": "16px" },
                      model: {
                        value: _vm.searchValue,
                        callback: function ($$v) {
                          _vm.searchValue = $$v
                        },
                        expression: "searchValue",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "request",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.order },
            },
            [
              _c("z-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "prodinfo--table",
                attrs: {
                  columns: _vm.tableColumns,
                  data: _vm.detailList,
                  "max-height": 400,
                  pagination: false,
                  customDefault: {
                    height: "400px",
                    text:
                      "" +
                      (_vm.order.supplierId
                        ? _vm.$t("storage::in-stock::sku_select")
                        : _vm.$t("storage::in-stock::supplier_select")),
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "opt",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#e62c11" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.toDetele(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("system::function::delete")) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "skuId",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(row.skuId) +
                              _vm._s(
                                row.skuProperty ? "-" + row.skuProperty : ""
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "spuName",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "prodinfo--table__imgTd" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("ZImg", {
                                  staticStyle: {
                                    width: "250px",
                                    height: "250px",
                                  },
                                  attrs: { src: row.img },
                                }),
                                _c("ZImg", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    "margin-right": "10px",
                                  },
                                  attrs: { slot: "reference", src: row.img },
                                  slot: "reference",
                                }),
                              ],
                              1
                            ),
                            _c("div", [
                              _c("div", [_vm._v(_vm._s(row.title))]),
                              _c("div", [_vm._v(_vm._s(row.categoryName))]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "qty",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: {
                              label: "",
                              "label-width": "0",
                              prop: "detailList." + $index + ".qty",
                              rules: {
                                validator: _vm.checkQuantity,
                                prodObj: row,
                                trigger: "blur",
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { size: "small" },
                              model: {
                                value: row.qty,
                                callback: function ($$v) {
                                  _vm.$set(
                                    row,
                                    "qty",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "row.qty",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "totalPrice",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: {
                              label: "",
                              "label-width": "0",
                              prop: "detailList." + $index + ".totalPrice",
                              rules: {
                                validator: _vm.checkPrice,
                                prodObj: row,
                                trigger: "blur",
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { size: "small" },
                              model: {
                                value: row.totalPrice,
                                callback: function ($$v) {
                                  _vm.$set(
                                    row,
                                    "totalPrice",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "row.totalPrice",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "footer-fixed",
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("storage::in-stock::cancel")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.sumbit("saveAndCheck")
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("storage::in-stock::save_audit")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.sumbit("save")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("storage::in-stock::save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("sku-dialog", {
        attrs: {
          skuList: _vm.order.detailList,
          supplier: _vm.order.supplierId,
        },
        on: { addSku: _vm.addSku },
        model: {
          value: _vm.isShowAddSku,
          callback: function ($$v) {
            _vm.isShowAddSku = $$v
          },
          expression: "isShowAddSku",
        },
      }),
      _c("uploadDialog", {
        attrs: { type: "in", supplier: _vm.order.supplierId },
        on: { addSku: _vm.importSku },
        model: {
          value: _vm.isImportSku,
          callback: function ($$v) {
            _vm.isImportSku = $$v
          },
          expression: "isImportSku",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }